/* eslint-disable no-nested-ternary */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import DoneIcon from '@material-ui/icons/Done'
import CloseIcon from '@material-ui/icons/Close'
import { useStyles } from './ResultSampleTestCaseStyles'

function ResultSampleTestcase({ testcase, index, maximumMarks }) {
  const isTestcasePassed = testcase?.testCaseInfo?.status === 'PASSED'
  const testcaseStatus = isTestcasePassed ? 'passed' : 'failed'
  const currentMarks = isTestcasePassed ? maximumMarks : 0
  const classes = useStyles({ isTestcasePassed })
  return (
    <Grid container direction="column">
      <Grid container alignItems="center" className={classes.testCaseWrapper}>
        <Typography
          data-testid="render-test-case-status"
          className={classes.testCaseStatus}
        >
          Test case {index + 1} {testcaseStatus}
        </Typography>
        <Grid item className={classes.iconWrapper}>
          {isTestcasePassed ? (
            <DoneIcon
              data-testid="render-done-icon"
              className={classes.doneIcon}
            />
          ) : (
            <CloseIcon
              data-testid="render-close-icon"
              className={classes.closeIcon}
            />
          )}
        </Grid>
      </Grid>
      <Grid container justify="space-between" className={classes.resultMsg}>
        <Typography
          data-testid="render-duration"
          className={classes.testCaseDuration}
        >
          Finished in {(testcase?.duration / 1000).toFixed(2)} seconds
        </Typography>
        {currentMarks >= 0 && maximumMarks ? (
          <Typography data-testid="render-marks">
            <span className={classes.testCaseMarks}>
              {currentMarks}/{maximumMarks}
            </span>{' '}
            Marks
          </Typography>
        ) : (
          <Typography data-testid="render-empty-marks">
            <span className={classes.testCaseMarks}>0</span> Marks
          </Typography>
        )}
      </Grid>
      <Grid item className={classes.resultContainer}>
        <Grid container direction="column" className={classes.resultWrapper}>
          <Grid
            data-testid="render-input-text-and-value"
            container
            direction="column"
            className={classes.inputWrapper}
          >
            <Typography className={classes.inputHeading}>Input:</Typography>
            <Typography className={classes.inputText}>
              {typeof testcase?.input === 'string'
                ? testcase?.input
                : testcase?.input?.length > 0
                ? testcase?.input?.join(',')
                : testcase?.input?.[0]}
            </Typography>
          </Grid>
          <Grid
            data-testid="render-output-text-and-value"
            container
            direction="column"
            className={classes.outputWrapper}
          >
            <Typography className={classes.outputHeading}>Output:</Typography>
            <Typography className={classes.outputText}>
              {testcase?.outputLines?.length > 0 ? (
                <>{testcase?.outputLines?.join('\n')}</>
              ) : (
                <>Your code didn&#39;t output anything</>
              )}
            </Typography>
          </Grid>
          <Grid
            data-testid="render-expected-output-text-and-value"
            container
            direction="column"
            className={classes.expectedOutputWrapper}
          >
            <Typography className={classes.expectedOutputHeading}>
              Expected Output:
            </Typography>
            <Typography className={classes.expectedOutputText}>
              {testcase?.expectedOutput}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ResultSampleTestcase
